import * as yup from "yup";

export const createSISchema = yup.object().shape({
  name:yup.string().required("Required"),
  email:yup.string().required("Required"),
  contactNumber:yup.string().required("Required"),
  watsapppNumber:yup.string().required("Required"),
  enrollDate:yup.string().required("Required"),
  amountPaid:yup.string().required("Required"),
  paymentDate:yup.string().required("Required"),
  Address:yup.string().required("Required"),
  paymentMode:yup.string().required("Required"),
});
